import { render, staticRenderFns } from "./Rotorblades.vue?vue&type=template&id=12b89136&scoped=true&"
import script from "./Rotorblades.vue?vue&type=script&lang=ts&"
export * from "./Rotorblades.vue?vue&type=script&lang=ts&"
import style0 from "./Rotorblades.vue?vue&type=style&index=0&id=12b89136&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b89136",
  null
  
)

export default component.exports